// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vec-divider__Divider-module--WWRfK.ant-divider-horizontal {
    margin: 8px 0 !important;
}
`, "",{"version":3,"sources":["webpack://./vector/src/Divider/Divider.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B","sourcesContent":[".vec-divider:global(.ant-divider-horizontal) {\n    margin: 8px 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vecDivider": `vec-divider__Divider-module--WWRfK`
};
export default ___CSS_LOADER_EXPORT___;
